import {
    StyleSheet,
    Dimensions
} from 'react-native';

import {
    pt
} from '../../../../common/utils';

let winWidth = Dimensions.get('window').width;
let winHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
    head: {
        marginTop: pt(5),
        paddingHorizontal: pt(10),
        paddingVertical: pt(9),
        backgroundColor: '#fff',
        borderBottomWidth: 1,
        borderColor: '#E6E6E6'
    },
    headText: {
        color: '#333333',
        fontSize: pt(14)
    },
    couponList: {
        // backgroundColor: 'red',
        paddingHorizontal: pt(8),
        // paddingVertical: pt(10),
        height: pt(100),
        paddingTop: pt(10),
        paddingBottom: pt(5),
        backgroundColor: '#fff',
        flexDirection: 'row'
    },
    couponItem: {
        width: pt(150),
        height: pt(82),
        position: 'relative'
    },
    bg: {
        width: pt(150),
        height: pt(82)
    },
    body: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        paddingVertical: pt(13),
        paddingLeft: pt(13),
        paddingRight: pt(13)
    },
    bodyTitle: {
        fontSize: pt(13),
        color: '#333'
    },
    bodyInfo: {
        fontSize: pt(8),
        color: '#999999',
        marginTop: pt(2),
        height: pt(25)
    },
    bottom: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    giving: {
        fontSize: pt(11)
    },
    detailed: {
        fontSize: pt(9),
        color: '#666666'
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: pt(1),
        paddingVertical: pt(1)
    },
    IconRight: {
        width: pt(4),
        height: pt(7),
        marginLeft: pt(5),
        marginTop: pt(1)
    },
    container: {
        position: 'relative',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: winWidth,
        height: winHeight,
        zIndex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: pt(10),
        paddingRight: pt(10)
    },
    modalBody: {
        backgroundColor: '#fff',
        paddingHorizontal: pt(15),
        paddingVertical: pt(15),
        borderTopLeftRadius: pt(5),
        borderTopRightRadius: pt(5),
        borderBottomLeftRadius: pt(5),
        borderBottomRightRadius: pt(5),
        position: 'relative',
        width: pt(350)
    },
    parentCloseImg: {
        position: 'absolute',
        right: 0
    },
    closeImg: {
        width: pt(10),
        height: pt(10)
    },
    modalTitle: {
        textAlign: 'center',
        fontSize: pt(17),
        color: '#333333',
        fontWeight: 'bold',
        paddingBottom: pt(15)
    },
    modalSubtitle: {
        fontSize: pt(16),
        color: '#666',
        paddingBottom: pt(7)
    },
    modalContainer: {
        fontSize: pt(13),
        color: '#666'
    }
});

export default styles;
